import type { NoteName } from '@tunasong/schemas'
import { NoteLib } from '../note/index.js'
import { ALL_CHORDS } from './all-chords.js'
import { isChordNotes } from './chord-types.js'
import type { Chord } from './chord-types.js'
import { getName } from './get-name.js'
import { parseChordString } from './chord-regexp.js'

export const getChordNotes = (name: string): NoteName[] => {
  const parsed = parseChordString(name) // Validate the chord name format

  // Get the base chord name
  const baseName = parsed
    ? getName({
        root: parsed.root,
        variant: parsed?.variant,
      })
    : name

  const chordInfo = ALL_CHORDS[baseName]

  const chordNotes = new Set(chordInfo ? chordInfo.builder.getNotes() : [])
  if (parsed?.bassNote) {
    // If a bass note is specified, add it to the notes
    chordNotes.add(parsed.bassNote)
  }

  return Array.from(chordNotes)
}

export const getNotes = (chordOrChords: Chord | Chord[]): NoteName[] => {
  const allChords = Array.isArray(chordOrChords) ? chordOrChords : [chordOrChords]
  return NoteLib.sort([
    ...new Set(
      allChords.flatMap(c =>
        isChordNotes(c)
          ? c.notes
          : ([
              ...getChordNotes(
                getName({
                  ...c,
                  bassNote: undefined,
                })
              ),
              c.bassNote ? c.bassNote : null,
            ].filter(Boolean) as NoteName[])
      )
    ),
  ])
}
